import React, { Component } from 'react';
import PropTypes from 'prop-types';

import logo from '../images/icon-fnr.svg';
import Icon from './Icon';
import SocialSharer from './SocialSharer';

/**
 * SceneTab
 */

class SceneTab extends Component {
  constructor(props) {
    super(props);

    /** Refs */
    this.element = React.createRef();
    this.logo = React.createRef();
  }

  render() {
    const elementClass = this.props.index === 0 ? 'header-nav' : 'section-nav';
    return (
      <nav ref={this.element} className={`scene-tab ${elementClass}`}>
        {this.props.index === 0 ? (
          <>
            <a ref={this.logo} href="#scene0" className="logo" onClick={(event) => this.props.onSceneChange(event, this.props.index)}>
              <img src={logo} alt="Luxembourg National Research Fund" />
            </a>
            <a className="download" href={this.props.downloadLink.url} target="_blank" rel="noopener noreferrer">
              <Icon icon="arrow-down" layout="l-bg l-bg-blue-pale" /> <b dangerouslySetInnerHTML={{ __html: this.props.downloadLink.title }} />
            </a>
            <SocialSharer />
          </>
        ) : (
          <a href={`#scene${this.props.index}`} onClick={(event) => this.props.onSceneChange(event, this.props.index)}>
            {this.props.title}
          </a>
        )}
      </nav>
    );
  }
}

SceneTab.propTypes = {
  index: PropTypes.number.isRequired,
  title: PropTypes.string,
  downloadLink: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
  onSceneChange: PropTypes.func.isRequired,
};

export default SceneTab;
